import { useNavigate, useLocation } from "react-router-dom";
import {
  InstagramOutlined,
  FacebookOutlined,
  TwitterOutlined
} from "@ant-design/icons";

import img1 from "../../assets/Lunch/lunch3.jpg";
import img2 from "../../assets/Breakfast/breakfast2.jpg";
import img3 from "../../assets/Dinner/dinner5.jpg";
import img4 from "../../assets/Desserts/dessert4.jpg";
import img5 from "../../assets/Drinks/drink1.jpg";
import img6 from "../../assets/Desserts/dessert2.jpg";

const FooterScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
    }
  };

  const instaImages = [img1, img2, img3, img4, img5, img6];

  return (
    <footer className="bg-[#0A1E3F] text-[#F6F1EB]">
      <div className="max-w-7xl mx-auto px-6 py-14">

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-10 justify-items-center align-items-center">

          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wide">
              Contact Info
            </h3>

            <p className="text-sm text-[#F6F1EB]/80 leading-relaxed">
              Eella Cafe<br />
              Open Daily: 10 AM – 11 PM
            </p>

            <p className="mt-3 text-primary-400 text-sm">
              @eelaacafe.com
            </p>

            <p className="mt-2 text-sm text-[#F6F1EB]/80">
              +91 98765 43210
            </p>

            <div className="flex gap-3 mt-5">
              {[
                { icon: InstagramOutlined, link: "https://instagram.com" },
                { icon: FacebookOutlined, link: "https://facebook.com" },
                { icon: TwitterOutlined, link: "https://twitter.com" }
              ].map(({ icon: Icon, link }, index) => (
                <a
                  key={index}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 border border-[#F6F1EB]/40 flex items-center justify-center rounded hover:bg-primary-400 hover:text-black transition cursor-pointer"
                >
                  <Icon className="text-lg" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wide">
              Navigation
            </h3>

            <ul className="space-y-3 text-sm">
              <li>
                <span
                  onClick={() => handleNavigation("/")}
                  className="hover:text-primary-400 transition cursor-pointer"
                >
                  Home
                </span>
              </li>

              <li>
                <span
                  onClick={() => handleNavigation("/menu")}
                  className="hover:text-primary-400 transition cursor-pointer"
                >
                  Menu
                </span>
              </li>

              <li>
                <span
                  onClick={() => handleNavigation("/about")}
                  className="hover:text-primary-400 transition cursor-pointer"
                >
                  About
                </span>
              </li>

              <li>
                <span
                  onClick={() => handleNavigation("/contact")}
                  className="hover:text-primary-400 transition cursor-pointer"
                >
                  Contact
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 uppercase tracking-wide">
              Instagram
            </h3>

            <div className="grid grid-cols-3 gap-2">
              {instaImages.map((img, index) => (
                <div
                  key={index}
                  className="w-full h-20 overflow-hidden rounded cursor-pointer group"
                >
                  <img
                    src={img}
                    alt={`Instagram ${index + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-300"
                  />
                </div>
              ))}
            </div>

            <p className="mt-4 text-sm text-primary-400 hover:underline cursor-pointer">
              View More Photos
            </p>
          </div>
        </div>

        <div className="border-t border-[#F6F1EB]/20 mt-12 pt-6 text-center text-sm text-[#F6F1EB]/60">
          <ul className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8">
            <li className="flex items-center gap-2">
              Developed by Aditi & Aarya
            </li>
            <li className="flex items-center gap-2">
              <span>•</span>
              Ascensify Technologies
            </li>
            <li className="flex items-center gap-2">
              <span >•</span>
            Licenses</li>
          </ul>
        </div>

      </div>
    </footer>
  );
};

export default FooterScreen;
